import { createResource, type RouteResource } from 'react-resource-router';

import { fetchUiSettingsEndpoint } from '../endpoints';
import type { LogSettingsResponseType } from '../endpoints/types';

export const uiSettingsResource: RouteResource<LogSettingsResponseType> =
	createResource<LogSettingsResponseType>({
		type: 'ui-settings-resource',
		getKey: () => 'ui-settings-resource',
		getData: async () => fetchUiSettingsEndpoint(),
		maxAge: Infinity,
		isBrowserOnly: true,
	});
